import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BusinessCard from '../components/BusinessCard';
import { getCategory } from '../api';

export default function CategoryPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeSubcat, setActiveSubcat] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    getCategory(slug)
      .then(r => setData(r.data))
      .catch(() => setError('Categoria non trovata'))
      .finally(() => setLoading(false));
  }, [slug]);

  const filtered = activeSubcat
    ? data?.businesses?.filter(b => b.sottocategorie?.some(s => s.toLowerCase().includes(activeSubcat.toLowerCase())))
    : data?.businesses;

  return (
    <div style={{ backgroundColor: 'var(--mi-bg)' }}>
      <Header />
      <div className="mi-container py-10">

        {loading && (
          <div className="space-y-4">
            <div className="skeleton-shimmer h-10 rounded w-1/3" />
            <div className="skeleton-shimmer h-4 rounded w-2/3" />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
              {[1,2,3,4,5,6].map(i => (
                <div key={i} className="rounded-2xl overflow-hidden border" style={{ borderColor: 'var(--mi-border)' }}>
                  <div className="skeleton-shimmer" style={{ paddingTop: '56.25%' }} />
                  <div className="p-4 space-y-2">
                    <div className="skeleton-shimmer h-5 rounded w-3/4" />
                    <div className="skeleton-shimmer h-3 rounded w-1/2" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {error && (
          <div className="text-center py-20">
            <p className="font-display text-2xl mb-2" style={{ color: 'var(--mi-fg)' }}>{error}</p>
            <Link to="/attivita" className="text-sm hover:underline" style={{ color: 'var(--mi-accent)' }}>Torna all'archivio</Link>
          </div>
        )}

        {!loading && !error && data && (
          <>
            {/* Header */}
            <div className="mb-8">
              <h1 className="font-display text-4xl md:text-5xl tracking-tight mb-3" style={{ color: 'var(--mi-fg)' }}>
                {data.nome}
              </h1>
              <p className="text-base" style={{ color: 'var(--mi-text)' }}>
                {data.count} attività in questa categoria
              </p>
            </div>

            {/* Subcategories */}
            {data.sottocategorie?.length > 0 && (
              <div className="flex flex-wrap gap-2 mb-8">
                <button
                  onClick={() => setActiveSubcat(null)}
                  className="text-xs px-3 py-1.5 rounded-full border font-medium transition-colors"
                  style={{
                    borderColor: !activeSubcat ? 'var(--mi-fg)' : 'var(--mi-border)',
                    backgroundColor: !activeSubcat ? 'var(--mi-fg)' : '#fff',
                    color: !activeSubcat ? 'var(--mi-bg)' : 'var(--mi-text)',
                  }}
                >
                  Tutte ({data.count})
                </button>
                {data.sottocategorie.slice(0, 12).map((s) => (
                  <button
                    key={s.nome}
                    onClick={() => setActiveSubcat(s.nome === activeSubcat ? null : s.nome)}
                    className="text-xs px-3 py-1.5 rounded-full border font-medium transition-colors"
                    style={{
                      borderColor: activeSubcat === s.nome ? 'var(--mi-fg)' : 'var(--mi-border)',
                      backgroundColor: activeSubcat === s.nome ? 'var(--mi-fg)' : '#fff',
                      color: activeSubcat === s.nome ? 'var(--mi-bg)' : 'var(--mi-text)',
                    }}
                  >
                    {s.nome} ({s.count})
                  </button>
                ))}
              </div>
            )}

            {/* Grid */}
            {filtered?.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {filtered.map((b) => (
                  <BusinessCard key={b._id} business={b} />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <p style={{ color: 'var(--mi-text)' }}>Nessuna attività trovata per questa selezione.</p>
              </div>
            )}
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
